import { useFeatureFlag } from '@lensora/ui'
import { useQuery } from '@tanstack/react-query'

import { isSelfServeClient, useMe } from '@/hooks/use-me'
import { fetchBillingStatus } from '@/lib/billing'

// Whether the current scope has Growth-or-above access to grounded-search
// platforms (google-ai, perplexity, etc). Self-serve customers' plan tier is
// authoritative from /api/billing/status — billing's client-scope webhooks
// are forbidden from writing the tenant-wide `google_ai_platform` flag (see
// webhooks.ts), because one self-serve subscriber's plan must never leak the
// feature to every other customer sharing the "app" tenant. Reading only the
// tenant flag here would leave every self-serve Growth+ subscriber
// permanently locked out regardless of what they paid for. Tenant-scope
// (agency) users are unaffected — their webhook does write the tenant flag.
export function useGrowthPlus(): boolean {
  const tenantFlag = useFeatureFlag('google_ai_platform')
  const { data: me } = useMe()
  const selfServe = isSelfServeClient(me)

  const { data: billingStatus } = useQuery({
    queryKey: ['billing-status'],
    queryFn: fetchBillingStatus,
    enabled: selfServe,
    staleTime: 300_000,
  })

  if (selfServe) {
    return billingStatus?.planTier === 'growth' || billingStatus?.planTier === 'enterprise'
  }
  return tenantFlag
}
